module.exports = __webpack_public_path__ + "4731fc32.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/p_serial/filterCourse/hover_down.png
// module id = 1216
// module chunks = 5